import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {
  BottomNavigation,
  BottomNavigationItemProps,
  BottomNavigationSelectEvent,
} from '@progress/kendo-vue-layout';
import { computed, onMounted, ref, watch } from 'vue';
import useTranslations from '@/composables/useTranslations';
import BottomMobileMenuModal from '@/components/common/bottomMobileMenu/BottomMobileMenuModal.vue';
import { IMobileMenuItem } from '@/types/mobileMenuTypes';


export default /*@__PURE__*/_defineComponent({
  __name: 'BottomMobileMenu',
  props: {
    menuItems: { default: () => [] },
    title: { default: '' }
  },
  setup(__props: any) {

const props = __props;

const { translate: t } = useTranslations();
const isMobileMenuModalVisible = ref(false);

const bottomMenuItems = computed(() => {
  let newBottomMenuItems = props.menuItems
    .filter((item) => !item?.separator)
    .slice(0, 4)
    .map((item) => ({
      text: item?.title,
      id: item?.id,
      icon: item?.iconClass,
      url: item?.url,
      selected: item?.selected,
    }));

  if (props.menuItems.length > 4) {
    newBottomMenuItems = [
      ...newBottomMenuItems,
      {
        text: t('Menu'),
        id: '5',
        icon: ' navigation-sidebar-item__menu--icon cwx-old-icon hamburger-menu cwx-icon cwx-icon-before_menu',
        url: undefined,
        selected: false,
      },
    ];
  }

  return newBottomMenuItems as BottomNavigationItemProps[];
});

function handleBottomSelect(...args: [BottomNavigationSelectEvent] | unknown[]) {
  const [event] = args as [BottomNavigationSelectEvent];
  if (event.itemTarget?.id === '5') {
    isMobileMenuModalVisible.value = !isMobileMenuModalVisible.value;
  } else if (event.itemTarget?.url) {
    window.location.href = event.itemTarget?.url;
  }
}

function toggleBottomMobileMenuVisibleClass() {
  if (props.menuItems?.length > 0) {
    document.body.classList.add('bottom-mobile-menu-visible');
  } else {
    document.body.classList.remove('bottom-mobile-menu-visible');
  }
}

watch(
  () => props.menuItems,
  () => {
    toggleBottomMobileMenuVisibleClass();
  },
  { deep: true },
);

onMounted(() => {
  toggleBottomMobileMenuVisibleClass();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (bottomMenuItems.value?.length > 0)
      ? (_openBlock(), _createBlock(_unref(BottomNavigation), {
          key: 0,
          items: bottomMenuItems.value,
          "position-mode": 'fixed',
          onSelect: handleBottomSelect
        }, null, 8, ["items"]))
      : _createCommentVNode("", true),
    (isMobileMenuModalVisible.value)
      ? (_openBlock(), _createBlock(BottomMobileMenuModal, {
          key: 1,
          "menu-items": __props.menuItems,
          title: __props.title,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (isMobileMenuModalVisible.value = false))
        }, null, 8, ["menu-items", "title"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})